import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { AccessoryType, CollectedAccessories } from '../accessory.types';
import { getObjectKeyForAccessory } from '../serviceOrderUtils';
import { ServiceOrderExecutionFormErrors } from './useServiceOrderExecutionForm';

export const InvalidAccessoriesAlert = (props: { messageId: string }) => {
    return (
        <div className="alert alert-dismissible alert-danger margin-bottom-10">
            <div className="display-flex">
                <span className="text-color-danger text-size-18 margin-right-10 rioglyph rioglyph rioglyph-error-sign" />
                <div>
                    <span className="text-size-14">
                        <FormattedMessage id={props.messageId} />
                    </span>
                </div>
            </div>
        </div>
    );
};

export const AccessoriesInput = (props: {
    requestedAccessories: AccessoryType[];
    onChange: (collectedAccessories: CollectedAccessories) => void;
    collectedAccessoriesFormData: CollectedAccessories;
    accessoryErrors: Pick<ServiceOrderExecutionFormErrors, AccessoryType>;
    isDisabled: boolean;
}) => {
    const { requestedAccessories, onChange, collectedAccessoriesFormData } = props;
    return (
        <div>
            <label>
                <FormattedMessage id="outboundPortal.serviceOrder.sidebar.quantities" />
            </label>
            <div className="border rounded padding-15">
                {requestedAccessories.map((accessory: AccessoryType, idx) => (
                    <div
                        className={classNames(
                            idx + 1 < requestedAccessories.length && 'margin-bottom-20',
                            'display-flex justify-content-between align-items-center',
                        )}
                        key={accessory}
                    >
                        <label htmlFor={`${accessory}Input`} className="text-color-darkest text-size-16 ">
                            <FormattedMessage id={`outboundPortal.serviceOrder.sidebar.accessory.${accessory}`} />
                        </label>
                        <div
                            className={classNames('form-group margin-0', {
                                'has-feedback has-error': !!props.accessoryErrors[accessory],
                            })}
                        >
                            <div className="input-group">
                                <input
                                    id={`${accessory}Input`}
                                    className="width-60 form-control padding-right-0"
                                    disabled={props.isDisabled}
                                    value={
                                        collectedAccessoriesFormData[getObjectKeyForAccessory(accessory)]?.toString() ??
                                        ''
                                    }
                                    onChange={(event) => {
                                        if (isNaN(Number(event.currentTarget.value))) {
                                            return;
                                        }
                                        onChange({
                                            ...collectedAccessoriesFormData,
                                            [getObjectKeyForAccessory(accessory)]: Number(event.currentTarget.value),
                                        });
                                    }}
                                />
                                <div className="input-group-addon">
                                    <FormattedMessage id="outboundPortal.serviceOrder.sidebar.accessory.pcs" />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
